import PropTypes from 'prop-types'
import React from 'react'
import Layout from '../../../src/components/layouts'
import PageCategoriesRepository from '../../../src/repositories/PageCategoriesRepository'
import PageRepository from '../../../src/repositories/PageRepository'
import BlogPage from '../../../src/components/pages/Blog'
import { generateSeoData } from '../../../src/common/nextSeoUtils'
import { getFullUrlFromReq } from '../../../src/common/serverUtils'
import logger from '../../../src/common/logger'
import { jsonLdData } from '../../../src/common/constants/jsonLd'
import CustomJsonLd from '../../../src/components/shared/CustomJsonLd'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'

export async function getServerSideProps({
  params: { pid: page = 1 },
  req,
  preview,
}) {
  let categories = []
  let posts = []
  const currentPage = Number(page)
  if (!currentPage || currentPage < 1) {
    return { notFound: true }
  }

  if (currentPage === 1) {
    return {
      redirect: {
        destination: '/blog/',
      },
    }
  }

  try {
    categories = await PageCategoriesRepository.getInstance().getAll({
      'fields.slug[nin]': 'company,unassigned',
    })
    posts = await PageRepository.getInstance().getAllBlogs(
      { limit: 26 },
      { page: currentPage },
      preview
    )
  } catch (error) {
    logger.error(`Blog page: failed to get blogposts`, { currentPage, error })

    return { notFound: true }
  }

  if (posts.items.length < 1) {
    return {
      notFound: true,
    }
  }

  const pagePid = ['blog', 'page', page]
  const { canonicalUrl } = getFullUrlFromReq(req, pagePid)
  const seoData = generateSeoData({
    title: `Blog - All Articles | Page ${currentPage} of ${posts.countOfPages} | Freedom Debt Relief`,
    url: canonicalUrl,
    description: `Financial information and advice on debt relief, debt consolidation, home equity, personal finance tips and more. | Page ${currentPage} of ${posts.countOfPages}`,
  })

  return {
    props: {
      categories,
      posts,
      seoData,
      page,
    },
  }
}

const BlogPages = ({ posts, categories, seoData, page }) => (
  <Layout footerClassName="max-w-1400">
    <WithSeoOverrides {...seoData} />
    <CustomJsonLd
      id={'webPage'}
      data={jsonLdData(
        seoData?.title,
        seoData?.description,
        `/blog/page/${page}`
      )}
    />
    <BlogPage categories={categories} posts={posts} />
  </Layout>
)

BlogPages.propTypes = {
  categories: PropTypes.array.isRequired,
  posts: PropTypes.object.isRequired,
  seoData: PropTypes.object.isRequired,
  page: PropTypes.string,
}

export default BlogPages
